export const getters = {
  studentRoster(state) {
    return state.StudentRoster;
  },
  adultRoster(state) {
    return state.AdultRoster;
  },
  rosterClasses(state) {
    return state.RosterClasses;
  },
  adultRosterClasses(state) {
    return state.AdultRosterClasses;
  },
};
